/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_FraudInputs */



/**
* | output |
* | --- |
* | "Fraud" |
*
* @param {Sanction_Sub_FraudInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_fraud = /** @type {((inputs?: Sanction_Sub_FraudInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_FraudInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fraude")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fraude")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fraude")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frode")
	return /** @type {LocalizedString} */ ("Fraud")
});